import { ChangeHistoryContainer } from 'nomst/Stores/ChangeHistory/changeHistoryContainer';
import { action, computed, observable, makeObservable } from 'mobx';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';
import { IManager } from 'typings/manager';

export class ChangeHistoryStore {
    private _manager: IManager;
    @observable private _changeHistoryContainers: ChangeHistoryContainer[];
    @observable private _isLoading: boolean;
    @observable private _managerId: string;

    constructor() {
        makeObservable(this);
    }

    @computed
    get changeHistoryContainers(): Nullable<ChangeHistoryContainer[]> {
        return this._changeHistoryContainers;
    }

    @computed
    get manager(): IManager {
        return this._manager;
    }

    @computed
    get isLoading(): boolean {
        return this._isLoading;
    }

    @action
    setManager(manager: IManager): void {
        this._manager = manager;
    }

    @action
    async setManagerId(managerId: string): Promise<void> {
        this._managerId = managerId;
    }

    @action
    clearChangeHistoryContainer(): Nullable<void> {
        this._changeHistoryContainers = [];
    }

    @action
    async fetchChangeHistoryData(masterAccountId: string, cycleId: number): Promise<void> {
        if (this._managerId) {
            this._isLoading = true;
            this._changeHistoryContainers =
                await dataManagerFactory
                    .getManagerDataManager()
                    .getChangeHistoryContainers(masterAccountId, cycleId, this._managerId) ?? [];
            
            const dataManager = dataManagerFactory.getManagerDataManager();
            const response = (await dataManager?.getManagers(masterAccountId, cycleId, [this._managerId ?? '']));
            if (response) {
                this._manager = response[0];
            }
            this._isLoading = false;
        }
    }
}

export interface IChangeHistoryStore extends ChangeHistoryStore {}